/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Close_LabelInputs */

const en_media_import_close_label = /** @type {(inputs: Media_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close Media Import`)
};

const fr_media_import_close_label = /** @type {(inputs: Media_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer l'importation des medias`)
};

const de_media_import_close_label = /** @type {(inputs: Media_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medienimport schließen`)
};

const it_media_import_close_label = /** @type {(inputs: Media_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi importazione media`)
};

const ru_media_import_close_label = /** @type {(inputs: Media_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть импорт медиафайлов`)
};

const es_media_import_close_label = /** @type {(inputs: Media_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar importación de medios`)
};

const zh_cn2_media_import_close_label = /** @type {(inputs: Media_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭媒体导入`)
};

const ja_media_import_close_label = /** @type {(inputs: Media_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアのインポートを閉じる`)
};

const hi_media_import_close_label = /** @type {(inputs: Media_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया आयात बंद करें`)
};

const pt_pt2_media_import_close_label = /** @type {(inputs: Media_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar Importação de Mídia`)
};

/**
* | output |
* | --- |
* | "Close Media Import" |
*
* @param {Media_Import_Close_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_close_label = /** @type {((inputs?: Media_Import_Close_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Close_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_import_close_label(inputs)
	if (locale === "de") return de_media_import_close_label(inputs)
	if (locale === "it") return it_media_import_close_label(inputs)
	if (locale === "ru") return ru_media_import_close_label(inputs)
	if (locale === "es") return es_media_import_close_label(inputs)
	if (locale === "zh-CN") return zh_cn2_media_import_close_label(inputs)
	if (locale === "ja") return ja_media_import_close_label(inputs)
	if (locale === "hi") return hi_media_import_close_label(inputs)
	if (locale === "pt-PT") return pt_pt2_media_import_close_label(inputs)
	return en_media_import_close_label(inputs)
});